module.exports = __webpack_public_path__ + "img/dzjg.5981302f.png";